import React from 'react';

import { makeStyles } from 'tss-react/mui';
import TextField from '@mui/material/TextField';

const useStyles = makeStyles()(theme => ({
    outlinedRoot: {
        '&:hover $notchedOutline': {
            borderColor: theme.palette.primary.main,
        },
    },
    notchedOutline: {}
}));

const Input = React.forwardRef(({ disabled, className, InputProps, ...rest }, ref) => {
    const { classes } = useStyles();

    return (
        <TextField 
            color='primary' 
            variant='outlined'
            autoComplete='off'
            ref={ref}
            {...rest}
            InputProps={{
                classes: {
                    root: classes.outlinedRoot,
                    notchedOutline: classes.notchedOutline
                },
                ...InputProps
            }}
            disabled={disabled}
        />
    );
})

export default Input;